import { ITrainingPlan, IUser } from "./providers/interfaces";

export const LANG_CS = "cs";
export const LANG_EN = "en";
export const LANGS = [LANG_CS, LANG_EN] as const;
export const LANG_LS_ITEM = "lang";
export const DEFAULT_USER = {
	email: "",
	password: "",
};
export const ROUTES = {
	login: "/login",
	loginWithRegister: "/login?afterRegistration",
	schedule: "/schedule",
	profile: "/profile",
	register: "/register",
	unitsList: "/unitsList",
	mealsList: "/mealsList",
	ingredients: "/ingredients",
	recipes: "/recipes",
	messages: "/messages",
	home: "https://www.doitforyourself.cz",
	howitworks: "https://www.doitforyourself.cz/jak-to-funguje.html",
	gdpr: "https://www.doitforyourself.cz/gdpr.html",
	cookies: "https://www.doitforyourself.cz/cookies.html",
	conditions: "https://www.doitforyourself.cz/podminky-pouziti.html",
	weight: "/weight",
	tags: "/tags",
	statsChest: "/statsChest",
	statsWaist: "/statsWaist",
	statsSide: "/statsSide",
	statsEnergy: "/statsEnergy",
	statsInput: "/statsInput",
	preferences: "/preferences",
	favoriteRecipes: "/favoriteRecipes",
	users: "/users",
	mailTemplates: "/mailTemplates",
	menus: "/menus",
	verify: "/verify",
	verifyEmail: "/verifyEmail",
	forgotPassword: "/forgotPassword",
	resetPassword: "/resetPassword",
	loginAfterReset: "/login?passwordReset",
	unsubscribe: "/unsubscribe",
	root: "/",
};

// administrace edituje ceske texty v DB - server ji vzdy posila cestinu (X-Lang)
export const ADMIN_ROUTES = [ROUTES.unitsList, ROUTES.mealsList, ROUTES.ingredients, ROUTES.recipes, ROUTES.tags, ROUTES.users, ROUTES.mailTemplates, ROUTES.menus];
// minimalni delka hesla (registrace, obnova hesla), stejna hodnota je v server/users.php
export const PASSWORD_MIN_LENGTH = 8;
export const LS_JWT_KEY = "strankyJWT";
export const LS_LANG_KEY = "strankyLang";
export const DATE_CONST = {
	sunday: 6,
	daysPerWeek: 7,
	// 7. 3. 2022 je pondeli
	mondayYear: 2022,
	mondayMonth: 2,
	mondayDay: 7,
};
export const SCHEDULE_RANGE = {
	left: 0,
	middle: 1,
	right: 2,
};
export const DEFAULT_DATA = {
	error: "",
	jwt: "",
	logged: false,
	permissions: 0,
};
export const THEMES = {
	light: {
		text: "#000",
		background: "#fff",
		backgroundModal: "rgba(0, 0, 0, 0.7)",
		backgroundImage: "url(\"http://app.doitforyourself.cz/img/logo_black.svg\")",
		calendarColor: "#282828",
		calendarLine: "#282828",
		calendarBorder: "#282828",
		calendarWeekend: "#efefef",
		calendarWeekendBorder: "#888888",
		calendarActive: "#bceb3c",
		calendarArrow: "#727376",
		calendarPaid: "#f1f864",
		alertColor: "#000",
		tableHover: "#ccc",
		inputBg: "#fff",
		backgroundHasTitleDay: "linear-gradient(to bottom right, rgb(244, 244, 254) 0%, rgb(199, 199, 209) 100%)",
		backgroundHasTitleWeekend: "linear-gradient(to bottom right, rgb(202, 204, 214) 0%, rgb(149, 149, 159) 100%)",
		backgroundHasTitlePaid: "linear-gradient(to bottom right, #f3f9a6 0%, #cbc634 100%)",
		dayShadowOuter: "5px 5px 5px #aaaaaa",
		dayShadowInner: "inset 3px 3px 5px #aaa",
		buttonBackground: "linear-gradient(to bottom right, rgb(202, 204, 214) 0%, rgb(149, 149, 159) 100%)",
		buttonTextColor: "#282828",
		buttonTextColorDisable: "#727376",
		recipesLine: "1px solid #000000",
		recipesLineBold: "2px solid #000000",
	},
	dark: {
		text: "#fff",
		background: "#181a1e",
		backgroundModal: "rgba(0, 0, 0, 0.7)",
		backgroundImage: "url(\"http://app.doitforyourself.cz/img/logo_white.png\")",
		calendarColor: "#ccc",
		calendarLine: "#282828",
		calendarBorder: "#666",
		calendarWeekend: "#1f2125",
		calendarWeekendBorder: "#000",
		calendarActive: "#727272",
		calendarArrow: "#727376",
		calendarPaid: "#424242",
		alertColor: "#fff",
		tableHover: "#666",
		inputBg: "#000",
		backgroundHasTitleDay: "linear-gradient(to bottom right, rgb(84, 84, 94) 0%, rgb(39, 39, 39) 100%)",
		backgroundHasTitleWeekend: "linear-gradient(to bottom right, rgb(42, 44, 54) 0%, rgb(00, 00, 09) 100%)",
		backgroundHasTitlePaid: "linear-gradient(to bottom right, rgb(213, 219, 136) 0%, rgb(173,158,22) 100%)",
		dayShadowOuter: "5px 5px 5px #000000",
		dayShadowInner: "inset 5px 5px 5px #000000",
		buttonBackground: "linear-gradient(to bottom right, rgb(84, 84, 94) 0%, rgb(39, 39, 39) 100%)",
		buttonTextColor: "#fff",
		buttonTextColorDisable: "#727376",
		recipesLine: "1px solid #ffffff",
		recipesLineBold: "2px solid #ffffff",
	},
};
export const THEME_IS_DARK_THEME = "(prefers-color-scheme: dark)";
export const THEME_LS_ITEM = "theme";
export const IMAGE_MIME_TYPES = [
	"image/jpeg",
	"image/pjpeg",
	"image/png",
];
export const LIST_LIMIT = 10;
/* eslint-disable no-magic-numbers */
export const LIST_LIMIT_DOUBLE = LIST_LIMIT * 2;
// sestaveni jidelnicku na vic dni muze trvat nekolik sekund
export const REQUEST_TIMEOUT = 30000;
export const MS_PER_MINUTE = 60 * 1000;
export const MS_PER_DAY = 24 * 60 * MS_PER_MINUTE;
// kod chyby ze serveru, kdyz neni platne prihlaseni (jwt) - uzivatele odhlasime
export const ERROR_SESSION_EXPIRED = "common.sessionExpired";
export const STAT_WEIGHT = "váha";
export const KEYS = {
	ESC: "Escape",
	LEFT: "ArrowLeft",
	RIGHT: "ArrowRight",
	UP: "ArrowUp",
	DOWN: "ArrowDown",
	ENTER: "Enter",
};

export const DAYS: Array<string> = ["monday", "tuesday", "wednesday", "thursday", "friday", "saturday", "sunday"];

export const STAT_TYPES = {
	CHEST: "hrudník",
	SIDE: "boky",
	WAIST: "pas",
	WEIGHT: "váha",
	ENERGY: "energie",
};

export const INGREDIENT_REPLACER = "#ingredience#";
export const PHOTO_REPLACER = "#photo#";
export const DEFAULT_IMAGE_RECIPE = "https://app.doitforyourself.cz/img/default_recipes.jpg";

export const NEW_INGREDIENT = {
	name: "",
	proteins: 0,
	energy: 0,
	carbohydrates: 0,
	fats: 0,
	mean_weight_per_unit: 0,
	minimum_use: 0,
};

export const USER: IUser = {
	id: -1,
	email: "",
	name: "",
	surname: "",
	sex: "M",
	address: "",
	city: "",
	country: "",
	zipcode: "",
	// format 1991-05-01
	birthdate: "",
	height: 0,
	foto_uri: "",
	user_group: 0,
	permissions: 0,
	email_verified: false,
	news: false,
	max_difficulty: 5,
	training_plan_id: 0,
	food_plan_id: 0,
	lang: "",
	// bavic
	jwt: "",
	errors: [],
};

export const TRAINING_PLAN: ITrainingPlan = {
	multiply_const: 0,
	plan_description: "",
	plan_id: 0,
	plan_name: "",
	monday: 0,
	tuesday: 0,
	wednesday: 0,
	thursday: 0,
	friday: 0,
	saturday: 0,
	sunday: 0,
};

export const GENDER_VALUES = [{
	value: "M",
	transTitle: "common.male",
}, {
	value: "F",
	transTitle: "common.female",
}];

export const CAPTCHA_SECRET_V2 = "6LcsKVkjAAAAANpF2GJvQk3YUL_kiivaPjS3gvW4";

export const EMPTY_RECIPE_DESC = `#photo#
<p>Úvod</p>

<br>

#ingredience#

<br>
<p>
<ol style="list-style-position: inside; padding-left:0px;">
<li>POSTUP 1</li>
<li>POSTUP 2</li>
<li>POSTUP 3</li>
</ol>
</p>

<p>
Závěr
</p>`;

export const PROFILE_PHOTO_SIZE = 300;

export const SMALL_WIDTH_RESOLUTION_FOR_WEEKDAY = 700;

export const LENGHT_WEEKDAY_SUBSTRING = 2;

export const EXERCISES = ["Tabata", "Angličáky"];

export const MEALS = [{
	title: "Vajíčka",
	food_name: "Snídaně",
}, {
	title: "Oběd",
	food_name: "Kuře",
}];
